import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const post = (employees) =>
  requestsTemplates.post(mainPath, "/employees",employees);
